export default {
  title: 'Snelle acties',
  send_push_notification: {
    label: 'Pushmelding verzenden',
    description: 'Maak een nieuwe campagne aan',
  },
  email_campaign: {
    label: 'E-mailcampagne',
    description: 'Verzenden naar abonnees',
  },
  view_analytics: {
    label: 'Analytics bekijken',
    description: 'Campagneprestaties',
  },
};
